interface IRedirectMvi {
  appName: string;
  country: string;
  documentType: string;
  document: string;
  lastName: string;
}

const useIdentityValidationModule = () => {
  const baseUrl = process.env.REACT_APP_MVI_URL

  const redirectMvi = ({ appName, country, documentType, document, lastName }: IRedirectMvi) => {
    window.location.href = `${baseUrl}/${appName}/${country}/${documentType}/${document}/${lastName}`
  }
  return { redirectMvi }
}

export default useIdentityValidationModule
